import { PaginatedListResponse } from "@/domain/dto/BaseDataResponse";
import { CreatedItemResponseDTO } from "@/domain/dto/CreatedItemResponseDTO";
import { CreatePartnerDTO } from "@/domain/dto/CreatePartnerDTO";
import { Partner } from "@/domain/entities/Partner";
import { IPartnerRepository } from "@/domain/repositories/IPartnerRepository";
import { IPartnerRemoteDataSource } from "../datasources/interfaces/remote/IPartnerRemoteDataSource";
import ResponseDataMappers from "../mappers/ResponseDataMappers";
import PartnerDataMappers from "../mappers/PartnerDataMappers";
import { BaseListQueryParamsDTO } from "@/domain/dto/BaseQueryParamsDTO";
import { UpdatePlanExpirationDateDTO } from "@/domain/dto/UpdatePlanExpirationDateDTO";
import { AddPlanDTO } from "@/domain/dto/AddUsersToPlanDTO";
import { PartnerPlan } from "@/domain/entities/PartnerPlan";
import PartnerBatchMappers from "../mappers/PartnerBatchMappers";
import PartnerCodeMappers from "../mappers/PartnerCodeDataMappers";
import { ListPartnerQueryParamsDTO } from "@/domain/dto/ListPartnerQueryParamsDTO";
import { NewPartnerCreatedDTO } from "@/domain/dto/NewPartnerCreatedDTO";

export class PartnerRepository implements IPartnerRepository {
    dataSource: IPartnerRemoteDataSource
    constructor(dataSource: IPartnerRemoteDataSource) {
        this.dataSource = dataSource
    }
    async showBatch(batch_id: string): Promise<PartnerPlan> {
        const response = await this.dataSource.showBatch(batch_id)
        return PartnerBatchMappers.toDomain(response.data)
    }
    async listCodes(partner_id: string): Promise<PartnerPlan> {
        const response = await this.dataSource.listCodes(partner_id)
        return PartnerCodeMappers.toPlanDomain(response.data)
    }
    async create(params: CreatePartnerDTO): Promise<NewPartnerCreatedDTO> {
        const response = await this.dataSource.create(params)
        return {
            id: response.data.id,
            login: response.data.users[0].email,
            password: response.data.users[0].temp_password
        }
    }
    async show(id: string): Promise<Partner> {
        const response = await this.dataSource.show(id)
        return PartnerDataMappers.toDomainFromShow(response.data)
    }
    async updatePlanExpirationDate(params: UpdatePlanExpirationDateDTO): Promise<void> {
        return this.dataSource.updatePlanExpirationDate(params)
    }
    async list(params: ListPartnerQueryParamsDTO): Promise<PaginatedListResponse<Partner>> {
        const response = await this.dataSource.list(params)
        return ResponseDataMappers.toPaginatedListResponse(response, PartnerDataMappers.toDomainList(response.data))
    }
    addUsersToPlan(params: AddPlanDTO) {
        return this.dataSource.addUsersToPlan(params)
    }

}